// =========================================================
// * Vuetify Material Dashboard - v2.1.0
// =========================================================
//
// * Product Page: https://www.creative-tim.com/product/vuetify-material-dashboard
// * Copyright 2019 Creative Tim (https://www.creative-tim.com)
//
// =========================================================
//

import Vue from "vue"
import App from "./App.vue"
import router from "./router"
import store from "./store"
import "./plugins/base"
import "./plugins/chartist"
import "./plugins/vee-validate"
import vuetify from "./plugins/vuetify"
import i18n from "./i18n"
import "./plugins/vuetify-money"
import "./plugins/vue-tel-input"

// Import the Auth0 configuration
import { domain, clientId, audience } from "../auth_config.json"

// Import the plugin here
import { Auth0Plugin } from "./auth"

// Install the authentication plugin here
Vue.use(Auth0Plugin, {
  domain,
  clientId,
  audience, // NEW - configure the plugin with the audience value
  onRedirectCallback: (appState) => {
    router.push(
      appState && appState.targetUrl
        ? appState.targetUrl
        : window.location.pathname
    )
  },
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
  el: "#app",
  template: "<App/>",
  components: {
    App,
  },
})
